import cScroll from './cScroll.vue';

export default {
  install(Vue) {
    Vue.component('cScroll', cScroll);
  },
};
